import React, {useEffect, useState} from 'react';
import Web3 from 'web3';
import {Button, Icon, Loader, Segment} from 'semantic-ui-react';
import './App.css';
import Chains from './chains.json';
import Larp from './contracts/LarpBoxel.json';

const App = () => {
  const [account, setAccount] = useState(undefined);
  const [network, setNetwork] = useState(undefined);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState(0);
  const [tokensToMint, setTokensToMint] = useState(1);
  const {ethereum} = window;  //will be empty if no web3 wallet is injected by the browser
  const web3 = ethereum ? new Web3(ethereum) : undefined;
  const larp = web3 ? new web3.eth.Contract(Larp.abi, '0x854Cf02ea0e76662AbC5AE0f2Eb3d2f39CA78192') : undefined;

  //initiates connection with web3 wallet
  const connect = async () => {
    await web3.eth.requestAccounts();
  }
  
  //gets account and chainId
  const getAccount = async () => {
    const chainId = await web3.eth.getChainId();
    setNetworkName(chainId);
    const accounts = await web3.eth.getAccounts();
    setAccount(accounts[0]);  //there can be more than one connected accounts!
  };

  //converts chainId to network name, using the JSON from chainId.network
  const setNetworkName = chainId => {
    chainId = parseInt(chainId, 16);  //chainId are hexadecimal, while the JSON list is in decimal
    let chain = Chains.find(c => c.chainId === chainId);
    setNetwork(chain?.name || `private (chain ID: ${chainId})`);
  };

  useEffect(() => {
    //if there's a wallet
    if(web3) {
      getAccount();
      ethereum
        .on('accountsChanged', accounts => setAccount(accounts[0]))
        .on('chainChanged', chainId => setNetworkName(chainId));
    }
    else {
      console.error('no wallet installed!');
      setError('Please install a web3 wallet (like Metamask) and reload the page');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const getPrice = async () => {
      const response = await larp.methods.getPrice().call({from: account});
      setPrice(response);
    };
    if(account) {
      getPrice();
      console.log(`connected to ${network} with account ${account}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, network]);

  const mint = async () => {
    try {
      setLoading(true);
      if(tokensToMint === 1) {
        let response = await larp.methods.mintToken().send({from: account, value: price});
        console.log(response);
      }
      else {
        let value = mul(price, tokensToMint);
        let response = await larp.methods.mintMultipleTokens(tokensToMint).send({from: account, value});
        console.log(response);
      }
      setLoading(false);
    }
    catch(err) {
      console.error(err);
      setError(err.message);
      setLoading(false);
    }
  };

  const mul = (a, b) => (new Web3.utils.BN(a)).mul(new Web3.utils.BN(b));

  const RefreshButton = ({color}) => 
    <Button icon size="tiny" color={color} title="Refresh to retry" onClick={() => window.location.reload()}>
      <Icon name='refresh' />
    </Button>

  return (
    <Segment basic className="App">
      {
        error ?
          <div style={{color: 'red'}}>{error}&nbsp;
            <RefreshButton color="red" />
          </div>
        :
          loading ?
            <Loader active inline='centered'>Minting...</Loader>
          :
            account ?
              <div>
                I'd like to mint&nbsp;
                <select defaultValue={tokensToMint} onChange={e => setTokensToMint(e.target.value)}>
                {
                  Array(10).fill(0).map((_, i) => <option key={`${i}`} value={i+1}>{i+1}</option>)
                }
                </select>&nbsp;
                LARP Comics tokens&nbsp;&nbsp;
                <Button animated="vertical" onClick={mint} >
                  <Button.Content hidden>Mint!</Button.Content>
                  <Button.Content visible>
                    <Icon name="shop" />
                  </Button.Content>
                </Button>
                <br/><br/>
                (Total price: <span>{Web3.utils.fromWei(mul(price, tokensToMint), 'ether')}</span> ETH + gas)
              </div>
            : 
              <Button onClick={connect}>Connect your MetaMask</Button>
      }
    </Segment>
  );
};

export default App;
